export default "__VITE_ASSET__CU7JVL82__"